import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe( { name: 'time2string' } )
export class Time2StringPipe implements PipeTransform {
    transform ( value: Date ) {
      return moment(value).utc().format('DD.MM.YYYY HH:mm');
    }
}
